<h1 mat-dialog-title>{{title}}</h1>
<div mat-dialog-content>
  <p>{{text}}</p>

  <a href="{{link}}" target="_blank">{{ link }}</a>
</div>
<div mat-dialog-actions align="end">
  <button mat-raised-button (click)="onOkClick()" color="primary">Ok</button>
  <!--<button mat-raised-button (click)="onActionClick()" cdkFocusInitial color="accent">Show</button>-->
</div>
